export const episodNameReg = /[se]/i;
